(() => {
  const buttons = [...document.querySelectorAll('[data-filter]')];
  const cards = [...document.querySelectorAll('[data-kind]')];
  const status = document.querySelector('.result-count');
  status.textContent = `${cards.length} toys to discover`;
  buttons.forEach(button => button.addEventListener('click', () => {
    const filter = button.dataset.filter;
    buttons.forEach(item => {
      const selected = item === button;
      item.classList.toggle('active', selected);
      item.setAttribute('aria-pressed', String(selected));
    });
    cards.forEach(card => { card.hidden = filter !== 'all' && card.dataset.kind !== filter; });
    const count = cards.filter(card => !card.hidden).length;
    status.textContent = `${count} ${count === 1 ? 'toy' : 'toys'} to discover`;
  }));
})();

(() => {
  const dialog = document.querySelector('.fg-quickshop');
  if (!dialog || !dialog.showModal) return; // Ordinary product links remain usable.
  const $ = selector => dialog.querySelector(selector);
  const title = $('#fg-quickshop-title');
  const image = $('.fg-quickshop-image');
  const variants = $('#fg-variant');
  const quantity = $('#fg-quantity');
  const add = $('.fg-add');
  const availability = $('.fg-quickshop-availability');
  const message = $('.fg-cart-status');
  const success = $('.fg-cart-success');
  const root = document.body.dataset.root || '/';
  const money = value => new Intl.NumberFormat(document.documentElement.lang || 'en', {style:'currency', currency:document.body.dataset.currency || 'USD'}).format(value / 100);
  const records = new Map([...document.querySelectorAll('.product-card')].map(card => [card.querySelector('[data-quickshop]').dataset.quickshop, card]));
  let product = null, availabilityData = null, trigger = null, requestId = 0, busy = false;
  const safeImage = url => { try { const u = new URL(url, location.origin); return u.protocol === 'https:' ? u.href : ''; } catch { return ''; } };
  // Keep merchant description formatting, without executing embedded markup.
  function descriptionHTML(html) {
    const template = document.createElement('template');
    template.innerHTML = html || '';
    const allowed = new Set(['P','BR','UL','OL','LI','STRONG','B','EM','I','H2','H3','H4','A']);
    [...template.content.querySelectorAll('*')].reverse().forEach(node => {
      if (['SCRIPT','STYLE','IFRAME','OBJECT','FORM','INPUT'].includes(node.tagName)) { node.remove(); return; }
      if (!allowed.has(node.tagName)) { node.replaceWith(...node.childNodes); return; }
      const href = node.tagName === 'A' ? node.getAttribute('href') : null;
      [...node.attributes].forEach(attr => node.removeAttribute(attr.name));
      if (href && /^(https:\/\/|\/[^/])/.test(href)) { node.setAttribute('href',href); node.setAttribute('target','_blank'); node.setAttribute('rel','noopener'); }
    });
    return template.content;
  }
  function selectedVariant() { return product?.variants.find(v => String(v.id) === variants.value); }
  function updateVariant() {
    const variant = selectedVariant();
    const state = availabilityData?.variants.find(v => String(v.id) === variants.value);
    $('.fg-quickshop-price').textContent = variant ? money(variant.price) : '';
    const preorder = Boolean(state?.preorder);
    // Fail closed on stock semantics until the preorder-aware Shopify view is checked.
    add.disabled = busy || !variant?.available || !state?.available;
    add.textContent = preorder ? 'Pre-order — ' + money(variant.price) : variant ? 'Add to bag — ' + money(variant.price) : 'Add to bag';
    availability.textContent = !state ? 'Availability could not be confirmed. Please try again.' : !variant?.available || !state.available ? 'Currently sold out. See availability on the full product page.' : preorder ? 'Available to pre-order. Check the full product page for delivery details.' : 'Ready for their next adventure.';
    if (preorder) { add.disabled = true; availability.textContent = 'Available to pre-order. View the full product page for delivery details and ordering.'; }
    if (variant?.featured_image?.src) image.src = safeImage(variant.featured_image.src);
  }
  function close() { dialog.close(); }
  dialog.addEventListener('close', () => {
    requestId += 1;
    document.documentElement.classList.remove('fg-modal-open');
    dialog.querySelectorAll('video').forEach(video => video.pause());
    trigger?.focus({preventScroll:true});
  });
  $('.fg-modal-close').addEventListener('click',close);
  $('.fg-keep-playing').addEventListener('click',close);
  dialog.addEventListener('click',event => { if (event.target === dialog) { const r=dialog.getBoundingClientRect(); if (event.clientX<r.left || event.clientX>r.right || event.clientY<r.top || event.clientY>r.bottom) close(); } });
  variants.addEventListener('change', () => { message.textContent=''; success.hidden=true; updateVariant(); });
  async function open(handle, source) {
    const card = records.get(handle); if (!card) return;
    trigger = source;
    const current = ++requestId;
    product = null; availabilityData = null; busy = false;
    title.textContent = card.querySelector('h3').textContent;
    $('.fg-quickshop-intro').textContent = card.querySelector('.product-description').textContent;
    $('.fg-quickshop-meta').textContent = card.querySelector('.product-meta').textContent;
    image.src = card.querySelector('img').src; image.alt = title.textContent; image.hidden=false;
    $('.fg-gallery-thumbs').replaceChildren();
    $('.fg-quickshop-price').textContent = card.querySelector('.price').textContent;
    availability.textContent = 'Checking the little details…';
    message.textContent=''; success.hidden=true; quantity.value='1';
    variants.replaceChildren(); $('.fg-variant-field').hidden=true;
    $('.fg-product-details').replaceChildren(); $('.fg-full-details').open=false;
    $('.fg-full-product').href = root+'products/'+encodeURIComponent(handle);
    add.disabled=true; add.textContent='Checking availability…';
    const videoSlot=$('.fg-quickshop-video'); videoSlot.replaceChildren(); videoSlot.hidden=true;
    if (handle === 'wheel-loader') {
      const original=document.querySelector('[data-video="loader"] video');
      if(original) { const copy=document.createElement('video'); copy.controls=true; copy.playsInline=true; copy.preload='none'; copy.poster=original.poster; copy.src=original.querySelector('source').src; copy.setAttribute('aria-label',original.getAttribute('aria-label')); videoSlot.append(copy); }
    }
    document.querySelectorAll('video').forEach(video=>video.pause());
    document.documentElement.classList.add('fg-modal-open');
    dialog.showModal(); dialog.scrollTop=0; title.focus({preventScroll:true});
    try {
      const path=root+'products/'+encodeURIComponent(handle);
      const [p,s]=await Promise.all([fetch(path+'.js',{headers:{Accept:'application/json'}}),fetch(path+'?view=rarely-waitlist-json',{headers:{Accept:'text/html'}})]);
      if(!p.ok || !s.ok) throw Error('Product unavailable');
      const [data,state]=await Promise.all([p.json(),s.json()]);
      if(current!==requestId) return;
      if(data.handle!==handle || state.handle!==handle || !data.variants?.length || !state.variants?.length) throw Error('Product unavailable');
      product=data; availabilityData=state;
      data.variants.forEach(v=> { const option=document.createElement('option'); option.value=String(v.id); option.textContent=v.title + (!v.available?' — sold out':''); variants.append(option); });
      variants.value=String(data.variants.find(v=>v.available)?.id || data.variants[0].id);
      $('.fg-variant-field').hidden=data.variants.length===1 && data.variants[0].title==='Default Title';
      $('.fg-product-details').append(descriptionHTML(data.description));
      const photos=[image.src,...(data.images.length>1 ? data.images.map(safeImage) : [])].filter(Boolean);
      if(photos.length>1 || videoSlot.firstChild) photos.forEach((src,index)=> {
        const button=document.createElement('button'); button.type='button'; button.setAttribute('aria-label',`View photo ${index+1} of ${title.textContent}`);button.setAttribute('aria-pressed',String(index===0));
        const thumb=document.createElement('img'); thumb.src=src; thumb.alt=''; thumb.loading='lazy';button.append(thumb);
        button.addEventListener('click',()=> { image.src=src; image.hidden=false; videoSlot.hidden=true; videoSlot.querySelector('video')?.pause(); $('.fg-gallery-thumbs').querySelectorAll('button').forEach(b=>b.setAttribute('aria-pressed',String(b===button))); });
        $('.fg-gallery-thumbs').append(button);
      });
      if(videoSlot.firstChild) {
        const watch=document.createElement('button'); watch.type='button'; watch.className='fg-video-thumb'; watch.textContent='▶'; watch.setAttribute('aria-label','Watch the Wheel Loader in play'); watch.setAttribute('aria-pressed','false');
        watch.addEventListener('click',()=>{ image.hidden=true; videoSlot.hidden=false; $('.fg-gallery-thumbs').querySelectorAll('button').forEach(b=>b.setAttribute('aria-pressed',String(b===watch))); });
        $('.fg-gallery-thumbs').append(watch);
      }
      updateVariant();
    } catch {
      if(current!==requestId) return;
      availability.textContent='We couldn’t load this toy right now. Close and try again, or view its full product page.';
      add.disabled=true; add.textContent='Temporarily unavailable';
    }
  }
  document.addEventListener('click',event=> {
    const link=event.target.closest('a[data-quickshop]');
    if(!link || event.defaultPrevented || event.metaKey || event.ctrlKey || event.shiftKey || event.altKey || event.button!==0 || !records.has(link.dataset.quickshop)) return;
    event.preventDefault(); open(link.dataset.quickshop,link);
  });
  $('[data-fg-cart-form]').addEventListener('submit',async event=> {
    event.preventDefault();
    if(busy || add.disabled || !product) return;
    const amount=Number(quantity.value), variant=selectedVariant();
    if(!Number.isInteger(amount) || amount<1 || amount>99) { message.textContent='Choose a quantity from 1 to 99.'; return; }
    const current=requestId, addedTitle=title.textContent;
    busy=true;add.disabled=true;add.textContent='Adding to their adventures…';message.textContent='';success.hidden=true;
    try {
      const response=await fetch(root+'cart/add.js',{method:'POST',headers:{'Content-Type':'application/json',Accept:'application/json'},body:JSON.stringify({items:[{id:variant.id,quantity:amount}]})});
      const result=await response.json();
      if(!response.ok) throw Error(result.description || result.message || 'This quantity isn’t available. Please try a smaller amount.');
      if(current===requestId) { message.textContent=`${amount} × ${addedTitle} added to your bag.`; success.hidden=false; }
      // A failed count refresh must never turn a successful add into a retry prompt.
      fetch(root+'cart.js',{headers:{Accept:'application/json'}}).then(r=>r.ok?r.json():null).then(cart=>{ if(cart)document.querySelectorAll('[data-cart-count]').forEach(n=>n.textContent=String(cart.item_count)); }).catch(()=>{});
    } catch(error) {
      if(current===requestId) message.textContent=error instanceof TypeError ? 'The connection was interrupted. Check your bag before trying again.' : error.message;
    } finally { if(current===requestId) { busy=false; updateVariant(); } }
  });
  document.addEventListener('play',event=>{ if(event.target.tagName==='VIDEO') document.querySelectorAll('video').forEach(v=>{if(v!==event.target)v.pause();}); },true);
})();
